import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';


const authRoutes: Routes = [
    { path: 'login', component:  LoginComponent, canActivate: [] }
];

@NgModule({
    imports: [
        RouterModule.forChild(authRoutes),
    ],
    exports: [RouterModule],
})

export class AuthRoutingModule {

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/auth/auth-routing.module.ts